module.exports = __webpack_public_path__ + "img/home-part-b.b046c01e.png";